// NetProfitBarChart.tsx
import React from "react";
import Chart from "react-apexcharts";
import { useGetChartDataQuery } from "../service/reportsService";

const NetProfitBarChart = ({
  interval,
}: {
  interval: "WEEKLY" | "MONTHLY" | "YEARLY";
}) => {
  const { data: chartData } = useGetChartDataQuery(interval);

  const options = {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 5,
        borderRadiusApplication: "end" as const,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: chartData?.map((v) =>
        v?.dayName
          ? v.dayName
          : v?.month
            ? v?.month
            : v.weekStart
              ? v?.weekStart
              : v?.year,
      ),
    },
    yaxis: {
      title: {
        text: "Amount in OMR",
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: (val: number) => ` ${val} OMR`,
      },
    },
  };

  const series = [
    {
      name: "Net Profit",
      data: chartData?.map((v) => v.netProfit),
    },
    {
      name: "Revenue",
      data: chartData?.map((v) => v.revenue),
    },
    {
      name: "Free Cash Flow",
      data: chartData?.map((v) => v?.cashFlow),
    },
  ];

  return (
    <Chart
      options={options}
      series={series || []}
      type="bar"
      height={350}
      width={500}
    />
  );
};

export default NetProfitBarChart;
